import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import { ReactNode } from "react";
import './styles.css'

interface UnderlineButtonProps {
    icon?: any;
    children: ReactNode;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    className?: string;
}

function UnderlineButton({ icon, children, onClick, className }: UnderlineButtonProps) {
    const accessibility = useAccessibility();

    return (
        <button
            className={`underline-button ${className || ''}`}
            style={accessibility.textStyleAccessibility}
            onClick={onClick}
        >
            <u>{children}</u>
            {icon && <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={icon} />}
        </button>
    );
}

export default UnderlineButton;
